<script>
	import { createEventDispatcher } from "svelte";

	export let disabled = false;

	const dispatcher = createEventDispatcher();

	const add = () => {
		dispatcher("add");
	};

	const handleKeyPress = (e) => {
		if (e.key === "Enter") {
			dispatcher("add");
		}
	};

	let className = $$props.class ? " " + $$props.class : "";
</script>

<button
	class={className}
	on:click|preventDefault={add}
	on:keypress={handleKeyPress}
	{disabled}
	aria-label="Add"
	title="Add"
	type="submit">
	<slot></slot>
</button>

<style>
	button {
		position: relative;
		color: var(--color-primary);
		background-color: transparent;
		border: none;
		padding: 0;
		padding-left: 30px;
		font-family: "Proxima Nova";
		font-size: 18px;
		font-weight: 600;
	}

	button:before {
		position: absolute;
		content: "\002b";
		font-size: 2rem;
		line-height: 1;
		left: 0;
		top: -6px;
	}
</style>
